import { render, staticRenderFns } from "./index_Teachers.vue?vue&type=template&id=8cbf068a&scoped=true"
import script from "./index_Teachers.vue?vue&type=script&lang=js"
export * from "./index_Teachers.vue?vue&type=script&lang=js"
import style0 from "./index_Teachers.vue?vue&type=style&index=0&id=8cbf068a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbf068a",
  null
  
)

export default component.exports